export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-paint-bucket-f7b77df90ab2c5b1e112720750f472ff.svg";